import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import './CertificateLookup.css';
import axios from 'axios';

function CertificateLookup() {

    const driverPrices = [
        { idSku: "1", fullName: "Jeff Gordon", authenticationPrice: 25 },
        { idSku: "2", fullName: "Dale Earnhardt Sr", authenticationPrice: 25 },
        { idSku: "3", fullName: "Richard Petty", authenticationPrice: 25 },
        { idSku: "4", fullName: "Joey Logano", authenticationPrice: 15 },
        { idSku: "5", fullName: "Ryan Blaney", authenticationPrice: 15 },
        { idSku: "6", fullName: "William Byron", authenticationPrice: 15 },
        { idSku: "7", fullName: "Tyler Reddick", authenticationPrice: 15 },
        { idSku: "8", fullName: "Christopher Bell", authenticationPrice: 15 },
        { idSku: "9", fullName: "Kyle Larson", authenticationPrice: 15 },
        { idSku: "10", fullName: "Chase Elliott", authenticationPrice: 15 },
        { idSku: "11", fullName: "Denny Hamlin", authenticationPrice: 15 },
        { idSku: "12", fullName: "Alex Bowman", authenticationPrice: 15 },
        { idSku: "13", fullName: "Martin Truex Jr", authenticationPrice: 15 },
        { idSku: "14", fullName: "Austin Cindric", authenticationPrice: 15 },
        { idSku: "15", fullName: "Daniel Suarez", authenticationPrice: 15 },
        { idSku: "16", fullName: "Brad Keselowski", authenticationPrice: 15 },
        { idSku: "17", fullName: "Chase Briscoe", authenticationPrice: 15 },
        { idSku: "18", fullName: "Ty Gibbs", authenticationPrice: 15 },
        { idSku: "19", fullName: "Harrison Burton", authenticationPrice: 15 },
        { idSku: "20", fullName: "Chris Buescher", authenticationPrice: 15 },
        { idSku: "21", fullName: "Bubba Wallace", authenticationPrice: 15 },
        { idSku: "22", fullName: "Darrell Wallace Jr", authenticationPrice: 15 },
        { idSku: "23", fullName: "Ross Chastain", authenticationPrice: 15 },
        { idSku: "24", fullName: "Kyle Busch", authenticationPrice: 15 },
        { idSku: "25", fullName: "Carson Hocevar", authenticationPrice: 15 },
        { idSku: "26", fullName: "Todd Gilliland", authenticationPrice: 15 },
        { idSku: "27", fullName: "Michael McDowell", authenticationPrice: 15 },
        { idSku: "28", fullName: "Noah Gragson", authenticationPrice: 15 },
        { idSku: "29", fullName: "Ricky Stenhouse Jr", authenticationPrice: 15 },
        { idSku: "30", fullName: "Ryan Preece", authenticationPrice: 15 },
        { idSku: "31", fullName: "Josh Berry", authenticationPrice: 15 },
        { idSku: "32", fullName: "Erik Jones", authenticationPrice: 15 },
        { idSku: "33", fullName: "Daniel Hemric", authenticationPrice: 15 },
        { idSku: "34", fullName: "Zane Smith", authenticationPrice: 15 },
        { idSku: "35", fullName: "Justin Haley", authenticationPrice: 15 },
        { idSku: "36", fullName: "Austin Dillon", authenticationPrice: 15 },
        { idSku: "37", fullName: "Corey LaJoie", authenticationPrice: 15 },
        { idSku: "38", fullName: "John Hunter Nemechek", authenticationPrice: 15 },
        { idSku: "39", fullName: "Kaz Grala", authenticationPrice: 10 },
        { idSku: "40", fullName: "Jimmie Johnson", authenticationPrice: 15 },
        { idSku: "41", fullName: "Joey Hand", authenticationPrice: 15 },
        { idSku: "42", fullName: "Kamui Kobayashi", authenticationPrice: 15 },
        { idSku: "43", fullName: "William Brown", authenticationPrice: 15 },
        { idSku: "44", fullName: "Cameron Waters", authenticationPrice: 15 },
        { idSku: "45", fullName: "Shane Van Gisbergen", authenticationPrice: 15 },
        { idSku: "46", fullName: "Ty Dillon", authenticationPrice: 10 },
        { idSku: "47", fullName: "B.J McLeod", authenticationPrice: 10 },
        { idSku: "48", fullName: "Justin Allgaier", authenticationPrice: 15 },
        { idSku: "49", fullName: "JJ Yeley", authenticationPrice: 5 },
        { idSku: "50", fullName: "Riley Herbst", authenticationPrice: 15 },
        { idSku: "51", fullName: "Corey Heim", authenticationPrice: 15 },
        { idSku: "52", fullName: "Parker Retzlaff", authenticationPrice: 10 },
        { idSku: "53", fullName: "Kevin Harvick", authenticationPrice: 15 },
        { idSku: "54", fullName: "Matt Kenseth", authenticationPrice: 15 },
        { idSku: "55", fullName: "Adam Petty", authenticationPrice: 15 },
        { idSku: "56", fullName: "Kyle Petty", authenticationPrice: 15 },
        { idSku: "57", fullName: "Bobby Allison", authenticationPrice: 15 },
        { idSku: "58", fullName: "Bill Elliott", authenticationPrice: 15 },
        { idSku: "59", fullName: "Dale Jarrett", authenticationPrice: 15 },
        { idSku: "60", fullName: "Marvin Panch", authenticationPrice: 15 },
        { idSku: "61", fullName: "Buck Baker", authenticationPrice: 15 },
        { idSku: "62", fullName: "Red Farmer", authenticationPrice: 15 },
        { idSku: "63", fullName: "Ned Jarrett", authenticationPrice: 15 },
        { idSku: "64", fullName: "Benny Parsons", authenticationPrice: 15 },
        { idSku: "65", fullName: "Buddy Baker", authenticationPrice: 15 },
        { idSku: "66", fullName: "Junior Johnson", authenticationPrice: 15 },
        { idSku: "67", fullName: "David Pearson", authenticationPrice: 15 },
        { idSku: "68", fullName: "Darrell Waltrip", authenticationPrice: 15 },
        { idSku: "69", fullName: "Geoff Bodine", authenticationPrice: 15 },
        { idSku: "70", fullName: "AJ Foyt", authenticationPrice: 15 },
        { idSku: "71", fullName: "Lee Petty", authenticationPrice: 15 },
        { idSku: "72", fullName: "Fred Lorenzen", authenticationPrice: 15 },
        { idSku: "73", fullName: "Glen Wood", authenticationPrice: 15 },
        { idSku: "74", fullName: "Rex White", authenticationPrice: 15 },
        { idSku: "75", fullName: "Tim Richmond", authenticationPrice: 15 },
        { idSku: "76", fullName: "Terry Labonte", authenticationPrice: 15 },
        { idSku: "77", fullName: "Bobby Labonte", authenticationPrice: 15 },
        { idSku: "78", fullName: "Harry Gant", authenticationPrice: 15 },
        { idSku: "79", fullName: "Neil Bonnett", authenticationPrice: 15 },
        { idSku: "80", fullName: "Jack Ingram", authenticationPrice: 15 },
        { idSku: "81", fullName: "Mark Martin", authenticationPrice: 15 },
        { idSku: "82", fullName: "Ernie Irvan", authenticationPrice: 15 },
        { idSku: "83", fullName: "Hershel McGriff", authenticationPrice: 15 },
        { idSku: "84", fullName: "Sam Ard", authenticationPrice: 15 },
        { idSku: "85", fullName: "Ron Hornaday Jr", authenticationPrice: 15 },
        { idSku: "86", fullName: "Ryan Newman", authenticationPrice: 15 },
        { idSku: "87", fullName: "Greg Biffle", authenticationPrice: 15 },
        { idSku: "88", fullName: "Carl Edwards", authenticationPrice: 15 },
        { idSku: "89", fullName: "Randy Lajoie", authenticationPrice: 15 },
        { idSku: "90", fullName: "Kasey Kahne", authenticationPrice: 15 },
        { idSku: "91", fullName: "Mike Stefanik", authenticationPrice: 15 },
        { idSku: "92", fullName: "Kurt Busch", authenticationPrice: 15 },
        { idSku: "93", fullName: "Tony Stewart", authenticationPrice: 15 },
        { idSku: "94", fullName: "Cole Custer", authenticationPrice: 15 },
        { idSku: "95", fullName: "Austin Hill", authenticationPrice: 15 },
        { idSku: "96", fullName: "Chandler Smith", authenticationPrice: 15 },
        { idSku: "97", fullName: "​Sheldon Creed", authenticationPrice: 15 },
        { idSku: "98", fullName: "Jesse Love", authenticationPrice: 15 },
        { idSku: "99", fullName: "Sam Mayer", authenticationPrice: 15 },
        { idSku: "100", fullName: "Parker Kligerman", authenticationPrice: 10 },
        { idSku: "101", fullName: "Sammy Smith", authenticationPrice: 15 },
        { idSku: "102", fullName: "Ryan Sieg", authenticationPrice: 10 },
        { idSku: "103", fullName: "Brandon Jones", authenticationPrice: 10 },
        { idSku: "104", fullName: "Anthony Alfredo", authenticationPrice: 10 },
        { idSku: "105", fullName: "Brennan Poole", authenticationPrice: 5 },
        { idSku: "106", fullName: "Aric Almirola", authenticationPrice: 15 },
        { idSku: "107", fullName: "Josh Williams", authenticationPrice: 5 },
        { idSku: "108", fullName: "Jeb Burton", authenticationPrice: 5 },
        { idSku: "109", fullName: "Jeremy Clements", authenticationPrice: 5 },
        { idSku: "110", fullName: "Leland Honeyman Jr.", authenticationPrice: 5 },
        { idSku: "111", fullName: "Ryan Ellis", authenticationPrice: 5 },
        { idSku: "112", fullName: "Kyle Sieg", authenticationPrice: 5 },
        { idSku: "113", fullName: "Blaine Perkins", authenticationPrice: 5 },
        { idSku: "114", fullName: "Ryan Truex", authenticationPrice: 10 },
        { idSku: "115", fullName: "Josh Bilicki", authenticationPrice: 5 },
        { idSku: "116", fullName: "Carson Kvapil", authenticationPrice: 15 },
        { idSku: "117", fullName: "Garrett Smithley", authenticationPrice: 5 },
        { idSku: "118", fullName: "Hailie Deegan", authenticationPrice: 15 },
        { idSku: "119", fullName: "Connor Zilisch", authenticationPrice: 15 },
        { idSku: "120", fullName: "​Austin Green", authenticationPrice: 5 },
        { idSku: "121", fullName: "Joey Gase", authenticationPrice: 5 },
        { idSku: "122", fullName: "David Starr", authenticationPrice: 5 },
        { idSku: "123", fullName: "Jordan Anderson", authenticationPrice: 10 },
        { idSku: "124", fullName: "Dylan Lupton", authenticationPrice: 5 },
        { idSku: "125", fullName: "Ed Jones", authenticationPrice: 10 },
        { idSku: "126", fullName: "Alex Labbe", authenticationPrice: 5 },
        { idSku: "127", fullName: "Logan Bearden", authenticationPrice: 5 },
        { idSku: "128", fullName: "Nick Leitz", authenticationPrice: 5 },
        { idSku: "129", fullName: "Myatt Snider", authenticationPrice: 5 },
        { idSku: "130", fullName: "Brad Perez", authenticationPrice: 5 },
        { idSku: "131", fullName: "Caesar Bacarella", authenticationPrice: 5 },
        { idSku: "132", fullName: "Bubba Pollard", authenticationPrice: 10 },
        { idSku: "133", fullName: "Greg Van Alst", authenticationPrice: 5 },
        { idSku: "134", fullName: "Natalie Decker", authenticationPrice: 15 },
        { idSku: "135", fullName: "​Justin Bonsignore", authenticationPrice: 10 },
        { idSku: "136", fullName: "Patrick Gallagher", authenticationPrice: 5 },
        { idSku: "137", fullName: "Tommy Joe Martins", authenticationPrice: 5 },
        { idSku: "138", fullName: "Thomas Annunziata", authenticationPrice: 5 },
        { idSku: "139", fullName: "Daniil Kvyat", authenticationPrice: 15 },
        { idSku: "140", fullName: "Andre Castro", authenticationPrice: 5 },
        { idSku: "141", fullName: "Ryan Vargas", authenticationPrice: 5 },
        { idSku: "142", fullName: "Glen Reen", authenticationPrice: 5 },
        { idSku: "143", fullName: "Boris Said", authenticationPrice: 15 },
        { idSku: "144", fullName: "Armani Williams", authenticationPrice: 5 },
        { idSku: "145", fullName: "Morgen Baird", authenticationPrice: 5 },
        { idSku: "146", fullName: "Tim Viens", authenticationPrice: 5 },
        { idSku: "147", fullName: "Gus Dean", authenticationPrice: 5 },
        { idSku: "148", fullName: "Alon Day", authenticationPrice: 5 },
        { idSku: "149", fullName: "Connor Mosack", authenticationPrice: 10 },
        { idSku: "150", fullName: "Frankie Muniz", authenticationPrice: 15 },
        { idSku: "151", fullName: "Kenko Miura", authenticationPrice: 5 },
        { idSku: "152", fullName: "Kyle Keller", authenticationPrice: 5 },
        { idSku: "153", fullName: "Ty Majeski", authenticationPrice: 15 },
        { idSku: "154", fullName: "Christian Eckes", authenticationPrice: 15 },
        { idSku: "155", fullName: "Grant Enfinger", authenticationPrice: 15 },
        { idSku: "156", fullName: "Nick Sanchez", authenticationPrice: 15 },
        { idSku: "157", fullName: "Taylor Gray", authenticationPrice: 15 },
        { idSku: "158", fullName: "Rajah Caruth", authenticationPrice: 15 },
        { idSku: "159", fullName: "Tyler Ankrum", authenticationPrice: 10 },
        { idSku: "160", fullName: "Ben Rhodes", authenticationPrice: 15 },
        { idSku: "161", fullName: "Daniel Dye", authenticationPrice: 10 },
        { idSku: "162", fullName: "Layne Riggs", authenticationPrice: 10 },
        { idSku: "163", fullName: "Stewart Friesen", authenticationPrice: 10 },
        { idSku: "164", fullName: "Tanner Gray", authenticationPrice: 5 },
        { idSku: "165", fullName: "Matt Crafton", authenticationPrice: 10 },
        { idSku: "166", fullName: "Chase Purdy", authenticationPrice: 5 },
        { idSku: "167", fullName: "Dean Thompson", authenticationPrice: 5 },
        { idSku: "168", fullName: "Jake Garcia", authenticationPrice: 5 },
        { idSku: "169", fullName: "Bayley Currey", authenticationPrice: 5 },
        { idSku: "170", fullName: "Kaden Honeycutt", authenticationPrice: 5 },
        { idSku: "171", fullName: "Bret Holmes", authenticationPrice: 5 },
        { idSku: "172", fullName: "Timmy Hill", authenticationPrice: 5 },
        { idSku: "173", fullName: "Matt Mills", authenticationPrice: 5 },
        { idSku: "174", fullName: "Lawless Alan", authenticationPrice: 5 },
        { idSku: "175", fullName: "Spencer Boyd", authenticationPrice: 5 },
        { idSku: "176", fullName: "Stefan Parsons", authenticationPrice: 5 },
        { idSku: "177", fullName: "Jack Wood", authenticationPrice: 5 },
        { idSku: "178", fullName: "William Sawalich", authenticationPrice: 10 },
        { idSku: "179", fullName: "Conner Jones", authenticationPrice: 5 },
        { idSku: "180", fullName: "Thad Moffitt", authenticationPrice: 5 },
        { idSku: "181", fullName: "Dawson Sutton", authenticationPrice: 5 },
        { idSku: "182", fullName: "Mason Maggio", authenticationPrice: 5 },
        { idSku: "183", fullName: "Brett Moffitt", authenticationPrice: 5 },
        { idSku: "184", fullName: "Keith McGee", authenticationPrice: 5 },
        { idSku: "185", fullName: "Luke Fenhaus", authenticationPrice: 5 },
        { idSku: "186", fullName: "Brenden Queen", authenticationPrice: 10 },
        { idSku: "187", fullName: "Johnny Sauter", authenticationPrice: 10 },
        { idSku: "188", fullName: "Corey Day", authenticationPrice: 15 },
        { idSku: "189", fullName: "Colby Howard", authenticationPrice: 5 },
        { idSku: "190", fullName: "Justin Carroll", authenticationPrice: 5 },
        { idSku: "191", fullName: "Cory Roper", authenticationPrice: 5 },
        { idSku: "192", fullName: "Andres Perez de Lara", authenticationPrice: 5 },
        { idSku: "193", fullName: "Bryan Dauzat", authenticationPrice: 5 },
        { idSku: "194", fullName: "Ryan Reed", authenticationPrice: 5 },
        { idSku: "195", fullName: "Connor Hall", authenticationPrice: 5 },
        { idSku: "196", fullName: "Justin Mondeik", authenticationPrice: 5 },
        { idSku: "197", fullName: "Clay Greenfield", authenticationPrice: 5 },
        { idSku: "198", fullName: "Clint Bowyer", authenticationPrice: 15 },
        { idSku: "199", fullName: "Danny Bohn", authenticationPrice: 5 },
        { idSku: "200", fullName: "Dawson Cram", authenticationPrice: 5 },
        { idSku: "201", fullName: "Norm Benning", authenticationPrice: 5 },
        { idSku: "202", fullName: "Carter Fartuch", authenticationPrice: 5 },
        { idSku: "203", fullName: "Clayton Green", authenticationPrice: 5 },
        { idSku: "204", fullName: "Vicente Salas", authenticationPrice: 5 },
        { idSku: "205", fullName: "Codie Rohrbaugh", authenticationPrice: 5 },
        { idSku: "206", fullName: "Matthew Gould", authenticationPrice: 5 },
        { idSku: "207", fullName: "Memphis Villarreal", authenticationPrice: 5 },
        { idSku: "208", fullName: "Nathan Byrd", authenticationPrice: 5 },
        { idSku: "209", fullName: "Dale Quarterley", authenticationPrice: 5 },
        { idSku: "210", fullName: "Stephen Mallozzi", authenticationPrice: 5 },
        { idSku: "211", fullName: "Jennifer Cobb", authenticationPrice: 5 },
        { idSku: "212", fullName: "Toni Breidinger", authenticationPrice: 15 },
        { idSku: "213", fullName: "Tyler Tomassi", authenticationPrice: 5 },
        { idSku: "214", fullName: "Akinori Ogata", authenticationPrice: 5 },
        { idSku: "215", fullName: "Josh Reaume", authenticationPrice: 5 },
        { idSku: "216", fullName: "Blake Lothian", authenticationPrice: 5 },
        { idSku: "217", fullName: "Trey Hutchens III", authenticationPrice: 5 },
        { idSku: "218", fullName: "Jeffrey Earnhardt", authenticationPrice: 5 },
        { idSku: "219", fullName: "Jerry Bohlman", authenticationPrice: 5 },
        { idSku: "220", fullName: "Ben Kennedy", authenticationPrice: 5 },
        { idSku: "221", fullName: "Casey Atwood", authenticationPrice: 10 },
        { idSku: "222", fullName: "Joe Gibbs", authenticationPrice: 15 },
        { idSku: "223", fullName: "Rick Hendrick", authenticationPrice: 15 },
        { idSku: "224", fullName: "Tim Fedewa", authenticationPrice: 5 },
        { idSku: "225", fullName: "Carl Long", authenticationPrice: 5 },
        { idSku: "226", fullName: "Michael Annett", authenticationPrice: 5 },
        { idSku: "227", fullName: "Elliott Sadler", authenticationPrice: 5 },
        { idSku: "228", fullName: "Blake Koch", authenticationPrice: 5 },
        { idSku: "229", fullName: "Stephen Leicht", authenticationPrice: 5 },
        { idSku: "230", fullName: "Mike Harmon", authenticationPrice: 5 },
        { idSku: "231", fullName: "Brendan Gaughan", authenticationPrice: 5 },
        { idSku: "232", fullName: "Dakoda Artmstrong", authenticationPrice: 5 },
        { idSku: "233", fullName: "Ray Black Jr", authenticationPrice: 5 },
        { idSku: "234", fullName: "Justin Marks", authenticationPrice: 10 },
        { idSku: "235", fullName: "Mario Gosselin", authenticationPrice: 5 },
        { idSku: "236", fullName: "Jeff Green", authenticationPrice: 5 },
        { idSku: "237", fullName: "Derrike Cope", authenticationPrice: 10 },
        { idSku: "238", fullName: "Sam Hornish Jr", authenticationPrice: 10 },
        { idSku: "239", fullName: "Harrison Rhodes", authenticationPrice: 5 },
        { idSku: "240", fullName: "Drew Herring", authenticationPrice: 5 },
        { idSku: "241", fullName: "Martin Roy", authenticationPrice: 5 },
        { idSku: "242", fullName: "Morgan Shepherd", authenticationPrice: 10 },
        { idSku: "243", fullName: "Brandon Gdovic", authenticationPrice: 5 },
        { idSku: "244", fullName: "Todd Peck", authenticationPrice: 5 },
        { idSku: "245", fullName: "Stanton Barrett", authenticationPrice: 5 },
        { idSku: "246", fullName: "Brandon Hightower", authenticationPrice: 5 },
        { idSku: "247", fullName: "Chris Cockrum", authenticationPrice: 5 },
        { idSku: "248", fullName: "Scott Heckert", authenticationPrice: 5 },
        { idSku: "249", fullName: "Timothy Peters", authenticationPrice: 10 },
        { idSku: "250", fullName: "Cameron Hayley", authenticationPrice: 5 },
        { idSku: "251", fullName: "Spencer Gallagher", authenticationPrice: 5 },
        { idSku: "252", fullName: "Rico Abreu", authenticationPrice: 15 },
        { idSku: "253", fullName: "Austin Wayne Self", authenticationPrice: 5 },
        { idSku: "254", fullName: "Travis Kvapil", authenticationPrice: 10 },
        { idSku: "255", fullName: "John Wes Townley", authenticationPrice: 5 },
        { idSku: "256", fullName: "Tyler Young", authenticationPrice: 5 },
        { idSku: "257", fullName: "Matt Tifft", authenticationPrice: 5 },
        { idSku: "258", fullName: "Brandon Brown", authenticationPrice: 5 },
        { idSku: "259", fullName: "Cody Coughlin", authenticationPrice: 5 },
        { idSku: "260", fullName: "Caleb Holman", authenticationPrice: 5 },
        { idSku: "261", fullName: "Jesse Little", authenticationPrice: 5 },
        { idSku: "262", fullName: "Shane Lee", authenticationPrice: 5 },
        { idSku: "263", fullName: "Jake Griffin", authenticationPrice: 5 },
        { idSku: "264", fullName: "Mike Bliss", authenticationPrice: 10 },
        { idSku: "265", fullName: "Chris Fontaine", authenticationPrice: 5 },
        { idSku: "266", fullName: "Travis Pastrana", authenticationPrice: 15 },
        { idSku: "267", fullName: "Mason Diaz", authenticationPrice: 5 },
        { idSku: "268", fullName: "Ken Schrader", authenticationPrice: 15 },
        { idSku: "269", fullName: "Cale Gale", authenticationPrice: 5 },
        { idSku: "270", fullName: "Bobby Reuse", authenticationPrice: 5 },
        { idSku: "271", fullName: "Chris Windom", authenticationPrice: 15 },
        { idSku: "272", fullName: "Dalton Sargeant", authenticationPrice: 5 },
        { idSku: "273", fullName: "Korbin Forrister", authenticationPrice: 5 },
        { idSku: "274", fullName: "Ray Ciccarelli", authenticationPrice: 5 },
        { idSku: "275", fullName: "Mike Senica", authenticationPrice: 5 },
        { idSku: "276", fullName: "Camden Murphy", authenticationPrice: 5 },
        { idSku: "277", fullName: "Casey Mears", authenticationPrice: 10 },
        { idSku: "278", fullName: "Kyle Benjamin", authenticationPrice: 5 },
        { idSku: "279", fullName: "Scott Lagasse Jr", authenticationPrice: 10 },
        { idSku: "280", fullName: "Quin Houff", authenticationPrice: 5 },
        { idSku: "281", fullName: "Andy Lally", authenticationPrice: 10 },
        { idSku: "282", fullName: "Angela Ruch", authenticationPrice: 10 },
        { idSku: "283", fullName: "Vinnie Miller", authenticationPrice: 5 },
        { idSku: "284", fullName: "Stan Mullis", authenticationPrice: 5 },
        { idSku: "285", fullName: "Ernie Francis Jr", authenticationPrice: 5 },
        { idSku: "286", fullName: "Jamie McMurray", authenticationPrice: 15 },
        { idSku: "287", fullName: "Paul Menard", authenticationPrice: 15 },
        { idSku: "288", fullName: "Gray Gaulding", authenticationPrice: 5 },
        { idSku: "289", fullName: "Katherine Legge", authenticationPrice: 15 },
        { idSku: "290", fullName: "Blake Jones", authenticationPrice: 5 },
        { idSku: "291", fullName: "Mike Skeen", authenticationPrice: 5 },
        { idSku: "292", fullName: "Justin Fontaine", authenticationPrice: 5 },
        { idSku: "293", fullName: "Wendell Chavous", authenticationPrice: 5 },
        { idSku: "294", fullName: "Tanner Thorson", authenticationPrice: 10 },
        { idSku: "295", fullName: "Bo Le Mastus", authenticationPrice: 5 },
        { idSku: "296", fullName: "Spencer Davis", authenticationPrice: 5 },
        { idSku: "297", fullName: "Tyler Dippel", authenticationPrice: 5 },
        { idSku: "298", fullName: "Kyle Donahue", authenticationPrice: 5 },
        { idSku: "299", fullName: "Logan Seavey", authenticationPrice: 15 },
        { idSku: "300", fullName: "Tate Fogleman", authenticationPrice: 5 },
        { idSku: "301", fullName: "Derek Kraus", authenticationPrice: 10 },
        { idSku: "302", fullName: "Austin Theriault", authenticationPrice: 5 },
        { idSku: "303", fullName: "Jesse Iwuji", authenticationPrice: 5 },
        { idSku: "304", fullName: "Danica Patrick", authenticationPrice: 15 },
        { idSku: "305", fullName: "Landon Cassill", authenticationPrice: 5 },
        { idSku: "306", fullName: "Brian Scott", authenticationPrice: 5 },
        { idSku: "307", fullName: "Regan Smith", authenticationPrice: 10 },
        { idSku: "308", fullName: "Matt DiBenedetto", authenticationPrice: 15 },
        { idSku: "309", fullName: "Cole Whitt", authenticationPrice: 5 },
        { idSku: "310", fullName: "Reed Sorenson", authenticationPrice: 5 },
        { idSku: "311", fullName: "Josh Wise", authenticationPrice: 5 },
        { idSku: "312", fullName: "Brian Vickers", authenticationPrice: 10 },
        { idSku: "313", fullName: "David Gilliland", authenticationPrice: 10 },
        { idSku: "314", fullName: "David Reutimann", authenticationPrice: 15 },
        { idSku: "315", fullName: "Marcos Ambrose", authenticationPrice: 15 },
        { idSku: "316", fullName: "Scott Speed", authenticationPrice: 15 },
        { idSku: "317", fullName: "Kevin Conway", authenticationPrice: 5 },
        { idSku: "318", fullName: "Max Papis", authenticationPrice: 10 },
        { idSku: "319", fullName: "David Stremme", authenticationPrice: 15 },
        { idSku: "320", fullName: "Tony Rains", authenticationPrice: 10 },
        { idSku: "321", fullName: "Todd Bodine", authenticationPrice: 15 },
        { idSku: "322", fullName: "Robert Richardson Jr", authenticationPrice: 5 },
        { idSku: "323", fullName: "PJ Jones", authenticationPrice: 5 },
        { idSku: "324", fullName: "Michael Waltrip", authenticationPrice: 15 },
        { idSku: "325", fullName: "Terry Cook", authenticationPrice: 5 },
        { idSku: "326", fullName: "Chad McCumbee", authenticationPrice: 5 },
        { idSku: "327", fullName: "Steve Park", authenticationPrice: 15 },
        { idSku: "328", fullName: "Scott Riggs", authenticationPrice: 15 },
        { idSku: "329", fullName: "Jacques Villeneuve", authenticationPrice: 15 },
        { idSku: "330", fullName: "John Andretti", authenticationPrice: 15 },
        { idSku: "331", fullName: "Jason Leffler", authenticationPrice: 15 },
        { idSku: "332", fullName: "Ron Fellows", authenticationPrice: 10 },
        { idSku: "333", fullName: "Hermie Sadler", authenticationPrice: 10 },
        { idSku: "334", fullName: "Jeff Burton", authenticationPrice: 15 },
        { idSku: "335", fullName: "Ward Burton", authenticationPrice: 15 },
        { idSku: "336", fullName: "Jeremy Mayfield", authenticationPrice: 15 },
        { idSku: "337", fullName: "Kenny Wallace", authenticationPrice: 15 },
        { idSku: "338", fullName: "Chad Chaffin", authenticationPrice: 10 },
        { idSku: "339", fullName: "Kevin Lepage", authenticationPrice: 10 },
        { idSku: "340", fullName: "Jon Wood", authenticationPrice: 10 },
        { idSku: "341", fullName: "Scott Wimmer", authenticationPrice: 10 },
        { idSku: "342", fullName: "Frank Kimmel", authenticationPrice: 10 },
        { idSku: "343", fullName: "Eric McClure", authenticationPrice: 10 },
        { idSku: "344", fullName: "Rusty Wallace", authenticationPrice: 15 },
        { idSku: "345", fullName: "Ricky Rudd", authenticationPrice: 15 },
        { idSku: "346", fullName: "Ricky Craven", authenticationPrice: 15 },
        { idSku: "347", fullName: "Sterling Marlin", authenticationPrice: 15 },
        { idSku: "348", fullName: "Jimmy Spencer", authenticationPrice: 15 },
        { idSku: "349", fullName: "Johnny Benson Jr", authenticationPrice: 10 },
        { idSku: "350", fullName: "Mike Skinner", authenticationPrice: 10 },
        { idSku: "351", fullName: "Bobby Hamilton", authenticationPrice: 10 },
        { idSku: "352", fullName: "Joe Nemechek", authenticationPrice: 10 },
        { idSku: "353", fullName: "Jerry Nadeau", authenticationPrice: 10 },
        { idSku: "354", fullName: "Hut Stricklin", authenticationPrice: 10 },
        { idSku: "355", fullName: "Stacy Compton", authenticationPrice: 10 },
        { idSku: "356", fullName: "Steve Grissom", authenticationPrice: 10 },
        { idSku: "357", fullName: "Rick Mast", authenticationPrice: 15 },
        { idSku: "358", fullName: "Buckshot Jones", authenticationPrice: 15 },
        { idSku: "359", fullName: "Ted Musgrave", authenticationPrice: 10 },
        { idSku: "360", fullName: "Shawna Robinson", authenticationPrice: 10 },
        { idSku: "361", fullName: "Jack Sprague", authenticationPrice: 15 },
        { idSku: "362", fullName: "Tim Sauter", authenticationPrice: 10 },
        { idSku: "363", fullName: "Dick Trickle", authenticationPrice: 15 },
        { idSku: "364", fullName: "Robert Pressley", authenticationPrice: 15 },
        { idSku: "365", fullName: "Chad Little", authenticationPrice: 10 },
        { idSku: "366", fullName: "Dave Marcis", authenticationPrice: 15 },
        { idSku: "367", fullName: "Wally Dallenbach Jr", authenticationPrice: 15 },
        { idSku: "368", fullName: "Kenny Irwin", authenticationPrice: 10 },
        { idSku: "369", fullName: "Johnny Benson", authenticationPrice: 10 },
        { idSku: "370", fullName: "David Green", authenticationPrice: 10 },
        { idSku: "371", fullName: "Rich Bickle", authenticationPrice: 10 },
        { idSku: "372", fullName: "Dave Blaney", authenticationPrice: 15 },
        { idSku: "373", fullName: "Lake Speed", authenticationPrice: 15 },
        { idSku: "374", fullName: "Elton Sawyer", authenticationPrice: 15 },
        { idSku: "375", fullName: "Greg Sacks", authenticationPrice: 10 },
        { idSku: "376", fullName: "Brett Bodine", authenticationPrice: 15 },
        { idSku: "377", fullName: "Larry Pearson", authenticationPrice: 15 },
        { idSku: "378", fullName: "Bill Venturini", authenticationPrice: 10 },
        { idSku: "379", fullName: "Jeff Purvis", authenticationPrice: 10 },
        { idSku: "380", fullName: "Ken Ragan", authenticationPrice: 10 },
        { idSku: "381", fullName: "David Ragan", authenticationPrice: 10 },
        { idSku: "382", fullName: "Rick Ware", authenticationPrice: 10 },
        { idSku: "383", fullName: "Ron Bouchard", authenticationPrice: 10 },
        { idSku: "384", fullName: "Buddy Arrington", authenticationPrice: 10 },
        { idSku: "385", fullName: "Phil Parsons", authenticationPrice: 10 },
        { idSku: "386", fullName: "Jimmy Means", authenticationPrice: 10 },
        { idSku: "387", fullName: "JD McDuffie", authenticationPrice: 10 },
        { idSku: "388", fullName: "Cale Yarborough", authenticationPrice: 15 },
        { idSku: "389", fullName: "Jody Ridley", authenticationPrice: 10 },
        { idSku: "390", fullName: "Richard Childress", authenticationPrice: 15 },
        { idSku: "391", fullName: "Donnie Allison", authenticationPrice: 15 },
        { idSku: "392", fullName: "Jason Keller", authenticationPrice: 10 },
        { idSku: "393", fullName: "Brian Keselowski", authenticationPrice: 10 },
        { idSku: "394", fullName: "James Buescher", authenticationPrice: 10 },
        { idSku: "395", fullName: "Tayler Malsam", authenticationPrice: 10 },
        { idSku: "396", fullName: "Kelly Bires", authenticationPrice: 10 },
        { idSku: "397", fullName: "Ricky Carmichael", authenticationPrice: 15 },
        { idSku: "398", fullName: "Mark McFarland", authenticationPrice: 10 },
        { idSku: "399", fullName: "Kyle Weatherman", authenticationPrice: 5 },
        { idSku: "400", fullName: "Joe Graf Jr", authenticationPrice: 5 },
        { idSku: "401", fullName: "Mason Massey", authenticationPrice: 5 },
        { idSku: "402", fullName: "CJ McLaughlin", authenticationPrice: 5 },
        { idSku: "403", fullName: "Jade Buford", authenticationPrice: 5 },
        { idSku: "404", fullName: "Patrick Emerling", authenticationPrice: 5 },
        { idSku: "405", fullName: "Preston Pardus", authenticationPrice: 5 },
        { idSku: "406", fullName: "Derek Griffith", authenticationPrice: 5 },
        { idSku: "407", fullName: "Kris Wright", authenticationPrice: 5 },
        { idSku: "408", fullName: "Miguel Paludo", authenticationPrice: 10 },
        { idSku: "409", fullName: "Parker Chase", authenticationPrice: 5 },
        { idSku: "410", fullName: "Drew Dollar", authenticationPrice: 5 },
        { idSku: "411", fullName: "Dillon Bassett", authenticationPrice: 5 },
        { idSku: "412", fullName: "Ronnie Bassett Jr", authenticationPrice: 5 },
        { idSku: "413", fullName: "Julia Landauer", authenticationPrice: 5 },
        { idSku: "414", fullName: "Spencer Pumpelly", authenticationPrice: 5 },
        { idSku: "415", fullName: "Will Rodgers", authenticationPrice: 5 },
        { idSku: "416", fullName: "Chad Finchum", authenticationPrice: 5 },
        { idSku: "417", fullName: "Tyler Matthews", authenticationPrice: 5 },
        { idSku: "418", fullName: "Ryan Repko", authenticationPrice: 5 },
        { idSku: "419", fullName: "Lawson Aschenbach", authenticationPrice: 5 },
        { idSku: "420", fullName: "Loris Hezemans", authenticationPrice: 5 },
        { idSku: "421", fullName: "Dexter Bean", authenticationPrice: 5 },
        { idSku: "422", fullName: "Kody Vanderwal", authenticationPrice: 5 },
        { idSku: "423", fullName: "Robby Lyons", authenticationPrice: 5 },
        { idSku: "424", fullName: "John Jackson", authenticationPrice: 5 },
        { idSku: "425", fullName: "Matt Jaskol", authenticationPrice: 5 },
        { idSku: "426", fullName: "Tanner Berryhill", authenticationPrice: 10 },
        { idSku: "427", fullName: "Dexter Stacey", authenticationPrice: 5 },
        { idSku: "428", fullName: "Raphael Lessard", authenticationPrice: 5 },
        { idSku: "429", fullName: "Tony Mrakovich", authenticationPrice: 5 },
        { idSku: "430", fullName: "Mike Marlar", authenticationPrice: 5 },
        { idSku: "431", fullName: "Landon Huffman", authenticationPrice: 5 },
        { idSku: "432", fullName: "Tyler Hill", authenticationPrice: 5 },
        { idSku: "433", fullName: "David Gravel", authenticationPrice: 15 },
        { idSku: "434", fullName: "Trey Hutchens", authenticationPrice: 5 },
        { idSku: "435", fullName: "Jason White", authenticationPrice: 5 },
        { idSku: "436", fullName: "Jessica Friesen", authenticationPrice: 10 },
        { idSku: "437", fullName: "Chad Chastain", authenticationPrice: 5 },
        { idSku: "438", fullName: "Buddy Kofoid", authenticationPrice: 10 },
        { idSku: "439", fullName: "Jake Drew", authenticationPrice: 5 },
        { idSku: "440", fullName: "Chris Hacker", authenticationPrice: 5 },
        { idSku: "441", fullName: "Christian Rose", authenticationPrice: 5 },
        { idSku: "442", fullName: "Derek Lemke", authenticationPrice: 5 },
        { idSku: "443", fullName: "Bryan Clauson", authenticationPrice: 15 },
        { idSku: "444", fullName: "Alex Palou", authenticationPrice: 15 },
        { idSku: "445", fullName: "Colton Herta", authenticationPrice: 15 },
        { idSku: "446", fullName: "Scott McLaughlin", authenticationPrice: 15 },
        { idSku: "447", fullName: "Will Power", authenticationPrice: 15 },
        { idSku: "448", fullName: "Patricio O'Ward", authenticationPrice: 15 },
        { idSku: "449", fullName: "Pato O'Ward", authenticationPrice: 15 },
        { idSku: "450", fullName: "Scott Dixon", authenticationPrice: 15 },
        { idSku: "451", fullName: "Kyle Kirkwood", authenticationPrice: 15 },
        { idSku: "452", fullName: "Josef Newgarden", authenticationPrice: 15 },
        { idSku: "453", fullName: "Santino Ferrucci", authenticationPrice: 15 },
        { idSku: "454", fullName: "Alexander Rossi", authenticationPrice: 15 },
        { idSku: "455", fullName: "Christian Lundgaard", authenticationPrice: 15 },
        { idSku: "456", fullName: "Felix Rosenqvist", authenticationPrice: 15 },
        { idSku: "457", fullName: "Rinus Veekay", authenticationPrice: 15 },
        { idSku: "458", fullName: "Marcus Armstrong", authenticationPrice: 15 },
        { idSku: "459", fullName: "Marcus Ericsson", authenticationPrice: 15 },
        { idSku: "460", fullName: "Linus Lundqvist", authenticationPrice: 15 },
        { idSku: "461", fullName: "Romain Grosjean", authenticationPrice: 15 },
        { idSku: "462", fullName: "Graham Rahal", authenticationPrice: 15 },
        { idSku: "463", fullName: "Pietro Fittipaldi", authenticationPrice: 10 },
        { idSku: "464", fullName: "Sting Ray Robb", authenticationPrice: 10 },
        { idSku: "465", fullName: "Kyffin Simpson", authenticationPrice: 15 },
        { idSku: "466", fullName: "Christian Rasmussen", authenticationPrice: 15 },
        { idSku: "467", fullName: "Nolan Siegel", authenticationPrice: 15 },
        { idSku: "468", fullName: "David Malukas", authenticationPrice: 15 },
        { idSku: "469", fullName: "Jack Harvey", authenticationPrice: 15 },
        { idSku: "470", fullName: "Conor Daly", authenticationPrice: 15 },
        { idSku: "471", fullName: "Agustin Canapino", authenticationPrice: 10 },
        { idSku: "472", fullName: "Theo Pourchaire", authenticationPrice: 15 },
        { idSku: "473", fullName: "Tom Blomqvist", authenticationPrice: 10 },
        { idSku: "474", fullName: "Toby Sowery", authenticationPrice: 10 },
        { idSku: "475", fullName: "Ed Carpenter", authenticationPrice: 15 },
        { idSku: "476", fullName: "Callum Ilott", authenticationPrice: 15 },
        { idSku: "477", fullName: "Luca Ghiotto", authenticationPrice: 15 },
        { idSku: "478", fullName: "Helio Castroneves", authenticationPrice: 15 },
        { idSku: "479", fullName: "TJ Bell", authenticationPrice: 15 },
        { idSku: "480", fullName: "Tristan Vautier", authenticationPrice: 10 },
        { idSku: "481", fullName: "Juri Vips", authenticationPrice: 15 },
        { idSku: "482", fullName: "Colin Braun", authenticationPrice: 10 },
        { idSku: "483", fullName: "Ryan Hunter-Reay", authenticationPrice: 15 },
        { idSku: "484", fullName: "Hunter McElrea", authenticationPrice: 15 },
        { idSku: "485", fullName: "Marco Andretti", authenticationPrice: 15 },
        { idSku: "486", fullName: "Louis Foster", authenticationPrice: 15 },
        { idSku: "487", fullName: "Jacob Abel", authenticationPrice: 10 },
        { idSku: "488", fullName: "Caio Collet", authenticationPrice: 10 },
        { idSku: "489", fullName: "Callum Hedge", authenticationPrice: 10 },
        { idSku: "490", fullName: "Salvador de Alba Jr", authenticationPrice: 10 },
        { idSku: "491", fullName: "James Roe", authenticationPrice: 10 },
        { idSku: "492", fullName: "Jamie Chadwick", authenticationPrice: 10 },
        { idSku: "493", fullName: "Yuven Sundaramoorthy", authenticationPrice: 10 },
        { idSku: "494", fullName: "Bryce Aron", authenticationPrice: 10 },
        { idSku: "495", fullName: "Reece Gold", authenticationPrice: 5 },
        { idSku: "496", fullName: "Myles Rowe", authenticationPrice: 15 },
        { idSku: "497", fullName: "Christian Bogle", authenticationPrice: 5 },
        { idSku: "498", fullName: "Jonathan Browne", authenticationPrice: 5 },
        { idSku: "499", fullName: "Josh Pierson", authenticationPrice: 5 },
        { idSku: "500", fullName: "Jack William Miller", authenticationPrice: 5 },
        { idSku: "501", fullName: "Christian Brooks", authenticationPrice: 5 },
        { idSku: "502", fullName: "Michael D'Orlando", authenticationPrice: 5 },
        { idSku: "503", fullName: "Nolan Allaer", authenticationPrice: 5 },
        { idSku: "504", fullName: "Niels Koolen", authenticationPrice: 5 },
        { idSku: "505", fullName: "Lindsay Brewer", authenticationPrice: 10 },
        { idSku: "506", fullName: "Jordan Missig", authenticationPrice: 5 },
        { idSku: "507", fullName: "Ricardo Escotto", authenticationPrice: 5 },
        { idSku: "508", fullName: "Taylor Ferns", authenticationPrice: 5 },
        { idSku: "509", fullName: "Josh Mason", authenticationPrice: 5 },
        { idSku: "510", fullName: "Kiko Porto", authenticationPrice: 5 },
        { idSku: "511", fullName: "Jagger Jones", authenticationPrice: 5 },
        { idSku: "512", fullName: "Devlin DeFrancesco", authenticationPrice: 10 },
        { idSku: "513", fullName: "Benjamin Pedersen", authenticationPrice: 5 },
        { idSku: "514", fullName: "Simon Pagenaud", authenticationPrice: 15 },
        { idSku: "515", fullName: "Tony Kanaan", authenticationPrice: 15 },
        { idSku: "516", fullName: "RC Enerson", authenticationPrice: 10 },
        { idSku: "517", fullName: "Stefan Wilson", authenticationPrice: 10 },
        { idSku: "518", fullName: "Dalton Kellett", authenticationPrice: 5 },
        { idSku: "519", fullName: "Tatiana Calderon", authenticationPrice: 10 },
        { idSku: "520", fullName: "JR Hildebrand", authenticationPrice: 15 },
        { idSku: "521", fullName: "Juan Pablo Montoya", authenticationPrice: 15 },
        { idSku: "522", fullName: "Simona De Silvestro", authenticationPrice: 10 },
        { idSku: "523", fullName: "Sage Karam", authenticationPrice: 10 },
        { idSku: "524", fullName: "Sebastien Bourdais", authenticationPrice: 15 },
        { idSku: "525", fullName: "James Hinchliffe", authenticationPrice: 15 },
        { idSku: "526", fullName: "Max Chilton", authenticationPrice: 10 },
        { idSku: "527", fullName: "Oliver Askew", authenticationPrice: 10 },
        { idSku: "528", fullName: "Cody Ware", authenticationPrice: 10 },
        { idSku: "529", fullName: "Charlie Kimball", authenticationPrice: 10 },
        { idSku: "530", fullName: "Ryan Norman", authenticationPrice: 10 },
        { idSku: "531", fullName: "Kevin Magnussen", authenticationPrice: 15 },
        { idSku: "532", fullName: "Zach Veach", authenticationPrice: 10 },
        { idSku: "533", fullName: "Fernando Alonso", authenticationPrice: 15 },
        { idSku: "534", fullName: "Spencer Pigot", authenticationPrice: 10 },
        { idSku: "535", fullName: "Ben Hanley", authenticationPrice: 10 },
        { idSku: "536", fullName: "James Davison", authenticationPrice: 10 },
        { idSku: "537", fullName: "Matheus Leist", authenticationPrice: 5 },
        { idSku: "538", fullName: "Pippa Mann", authenticationPrice: 15 },
        { idSku: "539", fullName: "Kyle Kaiser", authenticationPrice: 15 },
        { idSku: "540", fullName: "Oriol Servia", authenticationPrice: 15 },
        { idSku: "541", fullName: "Jordan King", authenticationPrice: 15 },
        { idSku: "542", fullName: "Gabby Chaves", authenticationPrice: 15 },
        { idSku: "543", fullName: "Carlos Munoz", authenticationPrice: 15 },
        { idSku: "544", fullName: "Rene Binder", authenticationPrice: 15 },
        { idSku: "545", fullName: "Alfonso Celis Jr", authenticationPrice: 15 },
        { idSku: "546", fullName: "Jay Howard", authenticationPrice: 15 },
        { idSku: "547", fullName: "Mikhail Aleshin", authenticationPrice: 15 },
        { idSku: "548", fullName: "Esteban Gutierrez", authenticationPrice: 15 },
        { idSku: "549", fullName: "Sebastian Saavedra", authenticationPrice: 15 },
        { idSku: "550", fullName: "Zachary DeMelo", authenticationPrice: 15 },
        { idSku: "551", fullName: "Buddy Lazier", authenticationPrice: 15 },
        { idSku: "552", fullName: "Jack Hawksworth", authenticationPrice: 15 },
        { idSku: "553", fullName: "Luca Filippi", authenticationPrice: 15 },
        { idSku: "554", fullName: "Townsend Bell", authenticationPrice: 15 },
        { idSku: "555", fullName: "Paul Tracy", authenticationPrice: 15 },
        { idSku: "556", fullName: "Matt Brabham", authenticationPrice: 15 },
        { idSku: "557", fullName: "Alex Tagliani", authenticationPrice: 15 },
        { idSku: "558", fullName: "James Jakes", authenticationPrice: 15 },
        { idSku: "559", fullName: "Ryan Briscoe", authenticationPrice: 15 },
        { idSku: "560", fullName: "Stefano Coletti", authenticationPrice: 15 },
        { idSku: "561", fullName: "Rodolfo Gonzalez", authenticationPrice: 15 },
        { idSku: "562", fullName: "Francesco Dracone", authenticationPrice: 15 },
        { idSku: "563", fullName: "Carlos Huertas", authenticationPrice: 15 },
        { idSku: "564", fullName: "Mike Conway", authenticationPrice: 15 },
        { idSku: "565", fullName: "Martin Plowman", authenticationPrice: 15 },
        { idSku: "566", fullName: "Franck Montagny", authenticationPrice: 15 },
        { idSku: "567", fullName: "Dario Franchitti", authenticationPrice: 15 },
        { idSku: "568", fullName: "EJ Viso", authenticationPrice: 15 },
        { idSku: "569", fullName: "AJ Allmendinger", authenticationPrice: 15 },
        { idSku: "570", fullName: "Ana Beatriz", authenticationPrice: 15 },
        { idSku: "571", fullName: "Lucas Luhr", authenticationPrice: 15 },
        { idSku: "572", fullName: "Wade Cunningham", authenticationPrice: 15 },
        { idSku: "573", fullName: "Michel Jourdain Jr", authenticationPrice: 15 },
        { idSku: "574", fullName: "Giorgio Patano", authenticationPrice: 15 },
        { idSku: "575", fullName: "Jean Alesi", authenticationPrice: 15 },
        { idSku: "576", fullName: "Bruno Junqueira", authenticationPrice: 15 },
        { idSku: "577", fullName: "Victor Meira", authenticationPrice: 15 },
        { idSku: "578", fullName: "Aleex Lloud", authenticationPrice: 15 },
        { idSku: "579", fullName: "Raphael Matos", authenticationPrice: 15 },
        { idSku: "580", fullName: "Thomas Scheckter", authenticationPrice: 15 },
        { idSku: "581", fullName: "Bertrand Baguette", authenticationPrice: 15 },
        { idSku: "582", fullName: "Davey Hamilton", authenticationPrice: 15 },
        { idSku: "583", fullName: "Hideki Mutoh", authenticationPrice: 15 },
        { idSku: "584", fullName: "Ho-Pin Tung", authenticationPrice: 15 },
        { idSku: "585", fullName: "Joao Paulo de Oliveira", authenticationPrice: 15 },
        { idSku: "586", fullName: "Dillon Battistini", authenticationPrice: 15 },
        { idSku: "587", fullName: "Milka Duno", authenticationPrice: 15 },
        { idSku: "588", fullName: "Mario Romancini", authenticationPrice: 15 },
        { idSku: "589", fullName: "Mario Andretti", authenticationPrice: 15 },
        { idSku: "590", fullName: "Michael Andretti", authenticationPrice: 15 },
        { idSku: "591", fullName: "Sarah Fisher", authenticationPrice: 15 },
        { idSku: "592", fullName: "Adam Carroll", authenticationPrice: 15 },
        { idSku: "593", fullName: "Roger Yasukawa", authenticationPrice: 15 },
        { idSku: "594", fullName: "AJ Foyt IV", authenticationPrice: 15 },
        { idSku: "595", fullName: "Jeff Bucknum", authenticationPrice: 15 },
        { idSku: "596", fullName: "Larry Foyt", authenticationPrice: 15 },
        { idSku: "597", fullName: "Felipe Giaffone", authenticationPrice: 15 },
        { idSku: "598", fullName: "Adrian Fernandez", authenticationPrice: 15 },
        { idSku: "599", fullName: "Scott Sharp", authenticationPrice: 15 },
        { idSku: "600", fullName: "Kosuke Matsuura", authenticationPrice: 15 },
        { idSku: "601", fullName: "Bryan Herta", authenticationPrice: 15 },
        { idSku: "602", fullName: "Roger Penske", authenticationPrice: 15 },
        { idSku: "603", fullName: "Chip Ganassi", authenticationPrice: 15 },
        { idSku: "604", fullName: "Alex Barron", authenticationPrice: 15 },
        { idSku: "605", fullName: "Patrick Carpentier", authenticationPrice: 15 },
        { idSku: "606", fullName: "Arie Luyendyk Jr", authenticationPrice: 15 },
        { idSku: "607", fullName: "Arie Luyendyk", authenticationPrice: 15 },
        { idSku: "608", fullName: "Thiago Medeiros", authenticationPrice: 15 },
        { idSku: "609", fullName: "Paul Dana", authenticationPrice: 15 },
        { idSku: "610", fullName: "Jimmy Kite", authenticationPrice: 15 },
        { idSku: "611", fullName: "Thomas Enge", authenticationPrice: 15 },
        { idSku: "612", fullName: "Jaques Lazier", authenticationPrice: 15 },
        { idSku: "613", fullName: "Kenny Brack", authenticationPrice: 15 },
        { idSku: "614", fullName: "Marty Roth", authenticationPrice: 15 },
        { idSku: "615", fullName: "Richie Hearn", authenticationPrice: 15 },
        { idSku: "616", fullName: "Arnd Meier", authenticationPrice: 15 },
        { idSku: "617", fullName: "Darren Manning", authenticationPrice: 15 },
        { idSku: "618", fullName: "Giorgio Pantano", authenticationPrice: 15 },
        { idSku: "619", fullName: "Greg Ray", authenticationPrice: 15 },
        { idSku: "620", fullName: "Robby Gordon", authenticationPrice: 15 },
        { idSku: "621", fullName: "Al Unser Jr", authenticationPrice: 15 },
        { idSku: "622", fullName: "Al Unser", authenticationPrice: 15 },
        { idSku: "623", fullName: "Scott Goodyear", authenticationPrice: 15 },
        { idSku: "624", fullName: "Raul Boesel", authenticationPrice: 15 },
        { idSku: "625", fullName: "Shigeaki Hattori", authenticationPrice: 15 },
        { idSku: "626", fullName: "Jeret Schroeder", authenticationPrice: 15 },
        { idSku: "627", fullName: "Robby Unser", authenticationPrice: 15 },
        { idSku: "628", fullName: "Dr Jack Miller", authenticationPrice: 15 },
        { idSku: "629", fullName: "Zak Morioka", authenticationPrice: 15 },
        { idSku: "630", fullName: "Stephan Gregoire", authenticationPrice: 15 },
        { idSku: "631", fullName: "Lyn St James", authenticationPrice: 15 },
        { idSku: "632", fullName: "Mark Dismore", authenticationPrice: 15 },
        { idSku: "633", fullName: "Jimmy Vasser", authenticationPrice: 15 },
        { idSku: "634", fullName: "Elseo Salazer", authenticationPrice: 15 },
        { idSku: "635", fullName: "Jeff Ward", authenticationPrice: 15 },
        { idSku: "636", fullName: "Billy Boat", authenticationPrice: 15 },
        { idSku: "637", fullName: "Buzz Calkins", authenticationPrice: 15 },
        { idSku: "638", fullName: "John Hollansworth Jr", authenticationPrice: 15 },
        { idSku: "639", fullName: "Airton Dare", authenticationPrice: 15 },
        { idSku: "640", fullName: "Niclas Jonsson", authenticationPrice: 15 },
        { idSku: "641", fullName: "Scott Harrington", authenticationPrice: 15 },
        { idSku: "642", fullName: "Billy Roe", authenticationPrice: 15 },
        { idSku: "643", fullName: "Stevie Reeves", authenticationPrice: 15 },
        { idSku: "644", fullName: "Tyce Carlson", authenticationPrice: 15 },
        { idSku: "645", fullName: "Roberto Guerrero", authenticationPrice: 15 },
        { idSku: "646", fullName: "Johnny Unser", authenticationPrice: 15 },
        { idSku: "647", fullName: "Steve Knapp", authenticationPrice: 15 },
        { idSku: "648", fullName: "Robbie Buhl", authenticationPrice: 15 },
        { idSku: "649", fullName: "Jon Herb", authenticationPrice: 15 },
        { idSku: "650", fullName: "Ronnie Johncox", authenticationPrice: 15 },
        { idSku: "651", fullName: "Bobby Regester", authenticationPrice: 15 },
        { idSku: "652", fullName: "Doug Didero", authenticationPrice: 15 },
        { idSku: "653", fullName: "Andy Hillenburg", authenticationPrice: 15 },
        { idSku: "654", fullName: "Dan Drinan", authenticationPrice: 15 },
        { idSku: "655", fullName: "Ross Cheever", authenticationPrice: 15 },
        { idSku: "656", fullName: "Eddie Cheever", authenticationPrice: 15 },
        { idSku: "657", fullName: "Memo Gidley", authenticationPrice: 15 },
        { idSku: "658", fullName: "Stan Wattles", authenticationPrice: 15 },
        { idSku: "659", fullName: "Donnie Beechler", authenticationPrice: 15 },
        { idSku: "660", fullName: "Emerson Fittipaldi", authenticationPrice: 15 },
        { idSku: "661", fullName: "Christian Fittipaldi", authenticationPrice: 15 },
        { idSku: "662", fullName: "Dean Hall", authenticationPrice: 15 },
        { idSku: "663", fullName: "Marco Greco", authenticationPrice: 15 },
        { idSku: "664", fullName: "Gil De Ferran", authenticationPrice: 15 },
        { idSku: "665", fullName: "Bobby Rahal", authenticationPrice: 15 },
        { idSku: "666", fullName: "Brian Till", authenticationPrice: 15 },
        { idSku: "667", fullName: "Frederik Ekblom", authenticationPrice: 15 },
        { idSku: "668", fullName: "Danny Sullivan", authenticationPrice: 15 },
        { idSku: "669", fullName: "Tom Sneva", authenticationPrice: 15 },
        { idSku: "670", fullName: "Juan Manuel Fangio II", authenticationPrice: 15 },
        { idSku: "671", fullName: "Mauricio Gugelmin", authenticationPrice: 15 },
        { idSku: "672", fullName: "Eric Bachelart", authenticationPrice: 15 },
        { idSku: "673", fullName: "Ross Bentley", authenticationPrice: 15 },
        { idSku: "674", fullName: "Franck Freon", authenticationPrice: 15 },
        { idSku: "675", fullName: "Alessandro Zampedri", authenticationPrice: 15 },
        { idSku: "676", fullName: "Scott Pruett", authenticationPrice: 15 },
        { idSku: "677", fullName: "Hiro Matsushita", authenticationPrice: 15 },
        { idSku: "678", fullName: "Andre Ribeiro", authenticationPrice: 15 },
        { idSku: "679", fullName: "Teo Fabi", authenticationPrice: 15 },
        { idSku: "680", fullName: "Rick Mears", authenticationPrice: 15 },
        { idSku: "681", fullName: "Geoff Brabham", authenticationPrice: 15 },
        { idSku: "682", fullName: "Pancho Carter", authenticationPrice: 15 },
        { idSku: "683", fullName: "Tony Bettenhausen Jr", authenticationPrice: 15 },
        { idSku: "684", fullName: "Guido Dacco", authenticationPrice: 15 },
        { idSku: "685", fullName: "Mike Groff", authenticationPrice: 15 },
        { idSku: "686", fullName: "Jim Crawford", authenticationPrice: 15 },
        { idSku: "687", fullName: "Gary Bettenhausen", authenticationPrice: 15 },
        { idSku: "688", fullName: "Randy Lewis", authenticationPrice: 15 },
        { idSku: "689", fullName: "Steve Bren", authenticationPrice: 15 },
        { idSku: "690", fullName: "Domonic Dobson", authenticationPrice: 15 },
        { idSku: "691", fullName: "Jon Beekuis", authenticationPrice: 15 },
        { idSku: "692", fullName: "Willy T Ribbs", authenticationPrice: 15 },
        { idSku: "693", fullName: "Ed Pimm", authenticationPrice: 15 },
        { idSku: "694", fullName: "Kevin Cogan", authenticationPrice: 15 },
        { idSku: "695", fullName: "Johnny Rutherford", authenticationPrice: 15 },
        { idSku: "696", fullName: "Josele Garza", authenticationPrice: 15 },
        { idSku: "697", fullName: "Bill Whittington", authenticationPrice: 15 },
        { idSku: "698", fullName: "Dale Coyne", authenticationPrice: 15 },
        { idSku: "699", fullName: "Steve Chassey", authenticationPrice: 15 },
        { idSku: "700", fullName: "Sheldon Kinser", authenticationPrice: 15 },
        { idSku: "701", fullName: "Dick Simon", authenticationPrice: 15 },
        { idSku: "702", fullName: "Bill Tempero", authenticationPrice: 15 },
        { idSku: "703", fullName: "Gordon Johncock", authenticationPrice: 15 },
        { idSku: "704", fullName: "Tom Bagley", authenticationPrice: 15 },
        { idSku: "705", fullName: "Danny Ongais", authenticationPrice: 15 },
        { idSku: "706", fullName: "Herm Johnson", authenticationPrice: 15 },
        { idSku: "707", fullName: "Jerry Karl", authenticationPrice: 15 },
        { idSku: "708", fullName: "Bill Alsup", authenticationPrice: 15 },
        { idSku: "709", fullName: "Roger Rager", authenticationPrice: 15 },
        { idSku: "710", fullName: "Larry Cannon", authenticationPrice: 15 },
        { idSku: "711", fullName: "Mike Mosley", authenticationPrice: 15 },
        { idSku: "712", fullName: "Mark Donohue", authenticationPrice: 15 },
        { idSku: "713", fullName: "Johnny Parsons", authenticationPrice: 15 },
        { idSku: "714", fullName: "Lloyd Ruby", authenticationPrice: 15 },
        { idSku: "715", fullName: "Swede Savage", authenticationPrice: 15 },
        { idSku: "716", fullName: "Colin Kaminsky", authenticationPrice: 10 },
        { idSku: "717", fullName: "Enaam Ahmed", authenticationPrice: 10 },
        { idSku: "718", fullName: "Rasmus Lindh", authenticationPrice: 10 },
        { idSku: "719", fullName: "Danial Frost", authenticationPrice: 10 },
        { idSku: "720", fullName: "Matteo Nannini", authenticationPrice: 10 },
        { idSku: "721", fullName: "Matthew Brabham", authenticationPrice: 10 },
        { idSku: "722", fullName: "Antonio Serravalle", authenticationPrice: 10 },
        { idSku: "723", fullName: "Manuel Sulaiman", authenticationPrice: 10 },
        { idSku: "724", fullName: "Ryan Phinny", authenticationPrice: 15 },
        { idSku: "725", fullName: "Finn Lazier", authenticationPrice: 15 },
        { idSku: "726", fullName: "Robert Megennis", authenticationPrice: 10 },
        { idSku: "727", fullName: "Alex Peroni", authenticationPrice: 10 },
        { idSku: "728", fullName: "Nikita Lastochkin", authenticationPrice: 15 },
        { idSku: "729", fullName: "Tristan Charpentier", authenticationPrice: 15 },
        { idSku: "730", fullName: "Santiago Urrutia", authenticationPrice: 15 },
        { idSku: "731", fullName: "Jarrett Andretti", authenticationPrice: 10 },
        { idSku: "732", fullName: "Julien Falchero", authenticationPrice: 15 },
        { idSku: "733", fullName: "Aaron Telitz", authenticationPrice: 15 },
        { idSku: "734", fullName: "Zachary Claman", authenticationPrice: 15 },
        { idSku: "735", fullName: "Robert Shwartzman", authenticationPrice: 15 },
        { idSku: "736", fullName: "Gio Ruggerio", authenticationPrice: 10 },
        { idSku: "737", fullName: "Dennis Hauger", authenticationPrice: 15 },
        { idSku: "738", fullName: "Lochie Hughes", authenticationPrice: 15 },
        { idSku: "739", fullName: "Davey Allison", authenticationPrice: 25 },
        { idSku: "740", fullName: "Alan Kulwicki", authenticationPrice: 25 },
        { idSku: "741", fullName: "Dale Earnhardt Jr", authenticationPrice: 25 },
        { idSku: "742", fullName: "Dan Wheldon", authenticationPrice: 25 },
        { idSku: "743", fullName: "Carson Ware", authenticationPrice: 5 },
    ];

    const [isExpanded, setIsExpanded] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [driverName, setDriverName] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [certificateId, setCertificateId] = useState("");
    const [certificateDetails, setCertificateDetails] = useState({
        certNumber: null,
        description: null,
        status: null,
        authenticatedDate: null,
        imageLocation: null,
        imageDate: null,
        driverName: null
    });
    const [invalidCoaId, setInvalidCoaId] = useState(false);

    const [drivers, setDrivers] = useState([]);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        const fetchDrivers = async () => {
            try {
                setDrivers(driverPrices.sort((a, b) =>
                    a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase())
                ));

            } catch (error) {
                console.error('Error fetching drivers:', error);
            }
        };
        fetchDrivers();
    }, []);

    const fetchDriverAuthentications = async (page = 1) => {
        try {
            const response = await axios.post(`https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/SearchAuthentications/GetPreviousAuthenticationsByDriverName`,
                {
                    driverName: driverName.fullName,
                    page: currentPage,
                    pageSize: 5,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            const { driverAuthenticationDtos } = response.data; // Extract the list

            if (driverAuthenticationDtos.length === 0 && page === 1) {
                // No results on the first page
                setSearchResults([]);
                setHasMore(false);
                return;
            }

            setSearchResults((prevResults) => [...prevResults, ...driverAuthenticationDtos]);
            setCurrentPage(page);
            setHasMore(driverAuthenticationDtos.length === 5); // If fewer than 5 results, no more pages
        } catch (error) {
            console.error("Error fetching driver authentications:", error);
        }
    };

    const fetchCertificateDetails = async () => {
        try {
            const response = await axios.post(
                `https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/SearchAuthentications/GetPreviousAuthenticationsByCoaId`,
                {
                    coaId: parseInt(certificateId),
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            // Map response data to display fields
            const data = response.data;
            if (!data) {
                setInvalidCoaId(true);
                setCertificateDetails({
                    certNumber: null,
                    description: null,
                    status: null,
                    authenticatedDate: null,
                    imageLocation: null,
                    imageData: null,
                    driverName: null
                });
                return;
            }

            setInvalidCoaId(false);
            setCertificateDetails({
                certNumber: data.coaId || "N/A",
                description: data.description || "N/A",
                status: "Authentic",
                authenticatedDate: data.authenticatedDate
                    ? new Date(data.authenticatedDate).toLocaleDateString()
                    : "N/A",
                imageLocation: data.imageLocation || null,
                imageData: data.imageData,
                driverName: data.driverName
            });
        } catch (error) {
            console.error("Error fetching certificate details:", error);
            setCertificateDetails({
                certNumber: "N/A",
                description: "N/A",
                status: "N/A",
                authenticatedDate: "N/A",
                imageLocation: null,
                driverName: "N/A"
            });
        }
    };

    const handleCoaIdSearch = () => {
        if (!certificateId.trim()) {
            alert("Please enter a Certificate ID.");
            return;
        }
        fetchCertificateDetails();
    };

    const handleSearch = () => {
        setSearchResults([]); // Clear previous results
        setCurrentPage(1); // Reset page number
        fetchDriverAuthentications(1);
    };

    const loadMore = () => {
        fetchDriverAuthentications(currentPage + 1);
    };

    const handleViewItem = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedItem(null);
    };

    return (
        <div className="coa-lookup-container">
            {/* Left Side */}
            <div className="coa-lookup-left-side">
                <div className="main-vla-container">
                    <h1 className="coa-lookup-h1">Certificate Lookup</h1>
                    <div className="coa-lookup-input-section">
                        <label htmlFor="certificate-id" className="coa-lookup-label">Enter your certificate id number</label>
                        <div className="coa-lookup-input-with-button">
                            <input
                                id="certificate-id"
                                type="text"
                                placeholder="Certificate ID"
                                className="coa-lookup-input"
                                value={certificateId}
                                onChange={(e) => setCertificateId(e.target.value)}
                            />
                            <button className="coa-lookup-button" onClick={handleCoaIdSearch}>
                                Search
                            </button>
                        </div>
                    </div>
                    <div className="coa-lookup-collapsible-section">
                        <button onClick={toggleExpand} className="coa-lookup-collapsible-button">
                            Where to find the certificate Id number?
                        </button>
                        {isExpanded && (
                            <div className="coa-lookup-collapsible-content">
                                <p>The certificate ID number is located on the top right of your certificate document.</p>
                            </div>
                        )}
                    </div>
                    {invalidCoaId ? (
                        <div className="coa-lookup-error-message" style={{ textAlign: 'center', marginTop: '2rem', fontWeight: 'bold', color: '#c0392b' }}>
                            Invalid certificate number, please try again
                        </div>
                    ) : (
                        <>
                            <div className="coa-lookup-certificate-details">
                                {certificateDetails.certNumber && (
                                    <>
                                        <div className="coa-lookup-detail-row">
                                            <span className="coa-lookup-label">Certificate Number:</span>
                                            <span className="coa-lookup-value" id="cert-number">{certificateDetails.certNumber}</span>
                                        </div>
                                        <div className="coa-lookup-detail-row">
                                            <span className="coa-lookup-label">Driver Name:</span>
                                            <span className="coa-lookup-value" id="driver-name">{certificateDetails.driverName}</span>
                                        </div>
                                        <div className="coa-lookup-detail-row">
                                            <span className="coa-lookup-label">Description:</span>
                                            <span className="coa-lookup-value" id="cert-description">{certificateDetails.description}</span>
                                        </div>
                                        <div className="coa-lookup-detail-row">
                                            <span className="coa-lookup-label">Status:</span>
                                            <span className="coa-lookup-value" id="cert-status">{certificateDetails.status}</span>
                                        </div>
                                        <div className="coa-lookup-detail-row">
                                            <span className="coa-lookup-label">Date Authenticated:</span>
                                            <span className="coa-lookup-value" id="cert-date">{certificateDetails.authenticatedDate}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                            {certificateDetails.certNumber && certificateDetails.imageData && (
                                <img
                                    src={`data:image/jpeg;base64,${certificateDetails.imageData}`}
                                    alt="Certificate"
                                    className="coa-lookup-image-large"
                                />
                            )}
                        </>
                    )}
                </div>
            </div>

            {/* Right Side */}
            <div className="coa-lookup-right-side">
                <div className="main-vla-container">
                    <h1 className="coa-lookup-h1">Previous Authentications</h1>
                    <div className="coa-lookup-input-section">
                        <label htmlFor="driver-name" className="coa-lookup-label">Driver Name</label>
                        <div className="coa-lookup-input-with-button">
                            <Autocomplete
                                disablePortal
                                options={[{ fullName: 'Select a driver', idSku: '', authenticationPrice: 0 }, ...drivers]}
                                getOptionLabel={(option) => option.fullName}
                                isOptionEqualToValue={(option, value) => option.idSku === value.idSku}
                                value={driverName ?? null}
                                onChange={(event, newValue) => setDriverName(newValue)}
                                renderInput={(params) => <TextField {...params} placeholder="Select a driver" />}
                                className="coa-lookup-input-autocomplete"
                            />
                            <button className="coa-lookup-button" onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                    <div className="coa-lookup-results-section">
                        {searchResults.length > 0 ? (
                            <div className="coa-lookup-scrollable-list" style={{ height: '100%' }}>
                                {searchResults.map((result, index) => (
                                    <div key={index} className="coa-lookup-result-item">
                                        <img
                                            src={`data:image/jpeg;base64,${result.imageData}`} // Updated to use base64 data
                                            alt={result.driverName}
                                            className="coa-lookup-image-with-border"
                                        />
                                        <div className="coa-lookup-result-info">
                                            <p><strong>Certificate Number:</strong> {result.coaId}</p>
                                            <p><strong>Driver Name:</strong> {result.driverName}</p>
                                            <p><strong>Description:</strong> {result.description}</p>
                                            <p><strong>Date Authenticated:</strong> {new Date(result.authenticatedDate).toLocaleDateString()}</p>
                                        </div>
                                        <div className="coa-lookup-result-actions">
                                            <button
                                                className="coa-lookup-view-item-button"
                                                onClick={() => handleViewItem(result)}
                                            >
                                                View Item
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                {hasMore && (
                                    <button className="coa-lookup-load-more-button" onClick={loadMore}>Load More</button>
                                )}
                            </div>
                        ) : (
                            <p>No issued COAs matching the search results</p>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal */}
            {showModal && selectedItem && (
                <div className="coa-lookup-modal">
                    <div className="coa-lookup-modal-content">
                        <img
                            src={`data:image/jpeg;base64,${selectedItem.imageData}`}
                            alt={selectedItem.driverName}
                            className="coa-lookup-modal-image"
                        />
                        <p><strong>Certificate Number:</strong> {selectedItem.coaId}</p>
                        <p><strong>Driver Name:</strong> {selectedItem.driverName}</p>
                        <p><strong>Description:</strong> {selectedItem.description}</p>
                        <p><strong>Date Authenticated:</strong> {new Date(selectedItem.authenticatedDate).toLocaleDateString()}</p>
                        <button className="coa-lookup-modal-close-button" onClick={handleCloseModal}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CertificateLookup;